import React from "react";
import "../../../assets/css/user/customerorder/orderDetail.css";
import { useNavigate, useLocation } from "react-router-dom";
import Navbar from "../navbar/Navbar";
import SimpleBanner from "../general/SimpleBanner";
import Footer from "../footer/Footer";
import { Container } from "react-bootstrap";
import MarqueeBanner from "../Marqueebanner/Marqueebanner";

export default function OrderDetail() {
  const navigate = useNavigate();
  const location = useLocation();
  const order = location.state?.order;

  if (!order) {
    return (
      <Container fluid>
        <Navbar />
        <p className="text-center py-5">No order data found.</p>
        <Footer />
      </Container>
    );
  }

  // Payment calculation
  const subtotal = order.amount || 0;
  const discount = 0; // add field if available
  const taxRate = 0.05;
  const tax = Math.round((subtotal - discount) * taxRate);
  const total = subtotal - discount + tax;

  // Shop — from first cart item's deal
  const shop = order.tpcarts?.[0]?.tpdeal?.tpshop;

  // Timeline based on status
  const timelineSteps = [
    {
      label: "Confirmed by Shop",
      done: ["ongoing", "completed"].includes(order.status),
    },
    {
      label: "Service In Progress",
      done: ["ongoing", "completed"].includes(order.status),
    },
    { label: "Completed", done: order.status === "completed" },
  ];

  return (
    <Container fluid>
      <div>
        <MarqueeBanner />
        <Navbar />
        <SimpleBanner
          title="Order Detail"
          subtitle=""
          breadcrumbs={[
            { label: "Home", href: "/" },
            { label: "Orders", href: "/customer-orders" },
            { label: "Order Detail", href: "/order-detail" },
          ]}
        />

        {/* Header */}
        <div className="od-header">
          <button className="od-back" onClick={() => window.history.back()}>
            &#8592;
          </button>
          <div className="od-title-block">
            <h1 className="od-title">Order #{order.id}</h1>
            <span className="od-date">
              📅 Placed on{" "}
              {new Date(order.created_at).toLocaleDateString("en-GB")}
            </span>
          </div>
          <span className="od-status-badge">{order.status}</span>
        </div>

        <div className="od-body">
          {/* Left column */}
          <div className="od-left">
            {/* Deal Items */}
            <div className="od-card">
              <h2 className="od-card-title">🎁 Deal Items</h2>
              <ul className="od-items-list">
                {order.tpcarts?.length > 0 ? (
                  order.tpcarts.map((cart, index) => (
                    <li key={cart.id} className="od-item-row">
                      <span className="od-item-num">{index + 1}</span>
                      <div className="od-item-info">
                        <span className="od-item-name">
                          {cart.tpdeal?.deal_title || "N/A"}
                        </span>
                        <span className="od-item-qty">
                          Price: PKR {cart.tpdeal?.deal_price?.toLocaleString()}
                        </span>
                      </div>
                      <span className="od-item-tag">Included</span>
                    </li>
                  ))
                ) : (
                  <p className="text-muted">No deal items found</p>
                )}
              </ul>
            </div>

            {/* Order Timeline */}
            <div className="od-card">
              <h2 className="od-card-title">Order Timeline</h2>
              <ul className="od-timeline">
                {timelineSteps.map((step, i) => (
                  <li
                    key={i}
                    className={`od-tl-step ${step.done ? "done" : ""}`}
                  >
                    <span className="od-tl-dot" />
                    <span className="od-tl-label">{step.label}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Right column */}
          <div className="od-right">
            {/* Shop */}
            {/* Shop */}
            <div className="od-card">
              <h2 className="od-card-title">🏪 Seller / Shop</h2>

              {shop ? (
                <>
                  <p className="od-shop-name">🏪 {shop.shopname || "N/A"}</p>

                  <p className="od-shop-loc">
                    📍 {shop.shop_address || shop.businessAddress || "N/A"}
                  </p>

                  <p className="od-shop-loc">📞 {shop.phone || "N/A"}</p>

                  <button
                    className="od-btn-outline"
                    onClick={() =>
                      navigate("/shop", {
                        state: {
                          shop: shop,
                        },
                      })
                    }
                  >
                    View Shop
                  </button>
                </>
              ) : (
                <p className="text-muted">Shop info not available</p>
              )}
            </div>

            {/* Payment Summary */}
            <div className="od-card">
              <h2 className="od-card-title">💳 Payment Summary</h2>
              <div className="od-pay-rows">
                <div className="od-pay-row">
                  <span>Subtotal</span>
                  <span>PKR {subtotal.toLocaleString()}</span>
                </div>
                <div className="od-pay-row">
                  <span>Tax (5%)</span>
                  <span>PKR {tax}</span>
                </div>
                <div className="od-pay-row od-pay-total">
                  <span>Total</span>
                  <span>PKR {total.toLocaleString()}</span>
                </div>
              </div>
              <p className="od-pay-method">Paid via Cash on Delivery</p>
            </div>

            {/* Actions */}
            <div className="od-card">
              <h2 className="od-card-title">Actions</h2>
              <button
                className="od-btn-danger"
                onClick={() => navigate(`/support-disputes`)}
              >
                ⚠ Raise Dispute
              </button>
              <button
                className="od-btn-ghost"
                onClick={() => navigate("/customer-orders")}
              >
                Back to Orders
              </button>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </Container>
  );
}
